import React, { useCallback } from 'react'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { DashboardGroupBy } from 'partner360/features/keyInitiatives/model/types'
import { useKeyInitiativesControlsForm } from 'partner360/features/keyInitiatives/ui/hooks/useKeyInitiativesControlsForm'

export const DisclaimerBanner = () => {
  const { groupBy } = useKeyInitiativesControlsForm()

  const getTranslation = useCallback(() => {
    switch (groupBy) {
      case DashboardGroupBy.BusinessPriority:
        return TRANSLATION_KEYS.disclaimerBanner.groupByPriority
      case DashboardGroupBy.Period:
        return TRANSLATION_KEYS.disclaimerBanner.groupByPeriod

      default:
        return ''
    }
  }, [groupBy])

  if (![DashboardGroupBy.BusinessPriority, DashboardGroupBy.Period].includes(groupBy)) {
    return null
  }

  return (
    <InfoBlock
      type={InfoBlockType.Warning}
      text={<Translation htmlAvailable text={getTranslation()} />}
    />
  )
}
